export default "__VITE_ASSET__Bj1eBoBl__"